import apptheme from "@/frame/theme/mixins/apptheme.js";
export default {
  mixins: [apptheme],
  methods: {
    generateStatusObj(item) {
      let status = item.char.status;
      let odid = item.char.odid;
      let obj = {
        icon: "source",
        color: this.ui.btnColor
      };
      if (status !== undefined && odid !== undefined) {
        if (status === "Created") {
          obj.icon = "source";
          obj.color = this.ui.btnColor;
        } else if (status === "Order") {
          obj.icon = "shopping_bag";
          obj.color = this.ui.btnColor;
        } else if (status === "Progress" && odid !== "") {
          obj.icon = "local_shipping";
          obj.color = this.ui.btnColor;
        } else if (status === "Progress" && odid === "") {
          obj.icon = "settings";
          obj.color = this.ui.btnColor;
        } else if (status === "Issue") {
          obj.icon = "warning";
          obj.color = this.ui.colorWarning;
        } else if (status === "Ready") {
          obj.icon = "check_box";
          obj.color = this.ui.btnColor;
        } else {
          obj.icon = "source";
          obj.color = this.ui.btnColor;
        }
      } else {
        if (status === "Created") {
          obj.icon = "source";
          obj.color = this.ui.btnColor;
        } else if (status === "Progress") {
          obj.icon = "settings";
          obj.color = this.ui.btnColor;
        } else if (status === "Issue") {
          obj.icon = "warning";
          obj.color = this.ui.colorWarning;
        } else if (status === "Ready") {
          obj.icon = "check_box";
          obj.color = this.ui.btnColor;
        } else {
          obj.icon = "source";
          obj.color = this.ui.btnColor;
        }
      }
      return obj;
    }
  }
};
